import { createSelector } from "@ngrx/store";
import { IShared } from "../../models/shared";
import { IAppState } from "../states/app";

export const selectRealEstateTypes = createSelector(
  (state: IAppState) => state.shared,
  (state: IShared) => state.realEstateTypes,
);

export const selectAuctionStatuses = createSelector(
  (state: IAppState) => state.shared,
  (state: IShared) => state.auctionStatuses,
);
